// extracted by mini-css-extract-plugin
export var actions = "_1a-0";
export var actionsContainer = "_1a-6";
export var border = "_1a-1";
export var childFullHeight = "_1a-d";
export var collapse = "_1a-2";
export var content = "_1a-8";
export var contentChild = "_1a-c";
export var fullscreen = "_1a-a";
export var hasLeftRadius = "_1a-i";
export var headerContainer = "_1a-3";
export var headerRow = "_1a-5";
export var hidePadding = "_1a-9";
export var navCollapsedGap = "_1a-j";
export var noScrollX = "_1a-k";
export var noScrollY = "_1a-l";
export var noTopPadding = "_1a-g";
export var optOutTopPadding = "_1a-b";
export var pageMain = "_1a-h";
export var pageOuter = "_1a-e";
export var pagePadding = "_1a-7";
export var profile = "_1a-m";
export var profileContainer = "_1a-n";
export var profileImage = "_1a-o";
export var profileMain = "_1a-p";
export var profileSubtitle = "_1a-r";
export var profileTitle = "_1a-q";
export var showLeftPadding = "_1a-f";
export var tabsWrapper = "_1a-4";
export var title = "_1a-s";